var objectToString = require('./staticObjectToString')

function helperCreateInInObjectString (type) {
  return function (obj) {
    return '[object ' + type + ']' === objectToString.call(obj)
  }
}

module.exports = helperCreateInInObjectString



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperCreateInInObjectString.js
// module id = Ran0
// module chunks = 137